import create from "zustand";
import { subscribeWithSelector } from "zustand/middleware";
import { ActionSlice, createActionSlice } from "./ActionSlice";
import { AssetSlice, createAssetSlice } from "./AssetSlice";
import { AppSlice, createAppSlice } from "./AppSlice";

// create the store to manage the behaviours of 3d objects
export const useStore = create<AssetSlice & ActionSlice & AppSlice>()(
  subscribeWithSelector((...a) => ({
    ...createAssetSlice(...a),
    ...createActionSlice(...a),
    ...createAppSlice(...a),
  }))
);
